import { ColorProps } from 'types';

// ==============================|| THEME 3 COLORS ||============================== //

const theme3: ColorProps = {
  // ==============================|| PAPER & BACKGROUND ||============================== //

  paper: '#ffffff',

  // ==============================|| PRIMARY - PAYANPUTRA DARK BLUE ||============================== //

  primaryLight: '#E8ECFA',
  primaryMain: '#182B72',
  primaryDark: '#101D52',
  primary200: '#8D9AC7',
  primary800: '#0B153F',

  // ==============================|| SECONDARY - PAYANPUTRA ORANGE ||============================== //

  secondaryLight: '#FFF0E3',
  secondaryMain: '#F58220',
  secondaryDark: '#D9680C',
  secondary200: '#F7B77D',
  secondary800: '#B94F00',

  // ==============================|| SUCCESS ||============================== //

  successLight: '#E8F7ED',
  success200: '#8BD5A2',
  successMain: '#17A94B',
  successDark: '#12863B',

  // ==============================|| ERROR ||============================== //

  errorLight: '#FDECEC',
  errorMain: '#D9534F',
  errorDark: '#C03935',

  // ==============================|| ORANGE ||============================== //

  orangeLight: '#FFF0E3',
  orangeMain: '#F58220',
  orangeDark: '#D9680C',

  // ==============================|| WARNING ||============================== //

  warningLight: '#FFF8E8',
  warningMain: '#F5A623',
  warningDark: '#D88900',

  // ==============================|| GREY ||============================== //

  grey50: '#F8FAFC',
  grey100: '#EEF2F6',
  grey200: '#E3E8EF',
  grey300: '#CDD5DF',
  grey500: '#697586',
  grey600: '#4B5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#0B1024',
  darkBackground: '#060A18',

  // dark 800 & 900
  darkLevel1: '#0A1028',
  darkLevel2: '#0D1535',

  // ==============================|| DARK TEXT ||============================== //

  darkTextTitle: '#FFFFFF',
  darkTextPrimary: '#F5F7FC',
  darkTextSecondary: '#AAB4D0',

  // ==============================|| DARK PRIMARY - BLUE ||============================== //

  darkPrimaryLight: '#DDE3F7',
  darkPrimaryMain: '#3D5299',
  darkPrimaryDark: '#304486',
  darkPrimary200: '#9CA9D0',
  darkPrimary800: '#22346F',

  // ==============================|| DARK SECONDARY - ORANGE ||============================== //

  darkSecondaryLight: '#FFF0E3',
  darkSecondaryMain: '#F58220',
  darkSecondaryDark: '#D9680C',
  darkSecondary200: '#F7B77D',
  darkSecondary800: '#B94F00'
};

export default theme3;